type ModuleWithDefault<T> = {
	default: T | ModuleWithDefault<T>;
};

function hasDefaultExport<T>(value: T | ModuleWithDefault<T>): value is ModuleWithDefault<T> {
	return typeof value === "object" && value !== null && "default" in value;
}

export function unwrapModuleDefault<T>(moduleValue: T | ModuleWithDefault<T>): T {
	let normalizedValue = moduleValue;

	while (hasDefaultExport(normalizedValue)) {
		normalizedValue = normalizedValue.default;
	}

	return normalizedValue as T;
}
